import React, { useEffect, useState } from "react";
import Search from "../containers/Index/Search/Search";
import NextTrip from "../containers/Index/NextTrip/NextTrip";
import SignatureFeatures from "../containers/Index/SignatureFeatures/SignatureFeatures";
import TravelAgency from "../containers/Index/TravelAgency/TravelAgency";
import GroupTour from "../containers/Index/GroupTour/GroupTour";
import AboutCompany from "../containers/Index/AboutCompany/AboutCompany";
import FamilyTravel from "../containers/Index/FamilyTravel/FamilyTravel";
import ParkingServicesSection from "../common/Components/ParkingServicesSection/ParkingServicesSection";
import axios from "axios";
import apiUrl from "../common/config/apiUrl";
import apiKey from "../common/config/apiKey";
import Seo from "../common/Components/Seo/Seo";
import { generatePageSEO, generateStructuredData } from "../common/utils/seoUtils";

const Home = () => {
  const [airports, setAirports] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${apiUrl}/airports?key=${apiKey}`);
        if (response?.data?.response_code == 200) {
          setAirports(response?.data?.data);
        }
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, []);

  // Generate SEO data with structured data
  const pageSEOData = generatePageSEO('home');
  const structuredData = [
    generateStructuredData('organization'),
    generateStructuredData('website'),
    generateStructuredData('service')
  ];

  return (
    <div>
      <Seo
        title={pageSEOData.title}
        description={pageSEOData.description}
        keywords={pageSEOData.keywords}
        url={pageSEOData.url}
        structuredData={structuredData}
        type="website"
      />
      <Search airports={airports} />
      <NextTrip />
      <SignatureFeatures />

    </div>
  );
};

export default Home;
